// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

body,
html {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
}
.login-page-container {
    display: flex;
    height: 100vh;
    background-color: #FFFFFF;
    justify-content: center;
    align-items: center;
}

.admin-login-content {
    height: 94vh;
    display: flex;
    width: 97%;
    background-color: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
}

.admin-image-container {
    flex: 1 1;
    background-color:#F4F4F4;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 32px 0px 0px 32px;
}
::placeholder{
    color:  #808080;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    font-family: 'Inter', sans-serif;

}
.admin-image-container img {
    max-width: 80%;
    object-fit: cover;
}


.login-box {
    flex: 1 1;
    padding: 40px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.logo-box {
    font-size: 24px;
    text-align: center;
    color: #232323;
    font-weight: 700;
    font-family: 'Inter', sans-serif;

    
}

.form-group-admin {
    margin-bottom: 20px;
}

.form-group-admin label {
  
    display: block;
    font-weight:500;
    margin-bottom: 5px;
    color:#232323;
    font-size: 16px;
    line-height: 22.36px;
    font-family: 'Inter', sans-serif;

}
.required {
    color: red;
    margin-left:3px;
}

.admin-form{
    margin-left: 14%;
    width: 100%;
}
.form-group-admin input {
    width: 80%;
    padding: 12px 10px 12px 10px;
    border: 1px solid  #D0D0D0 ;
    border-radius: 8px;
    font-size: 16px;
    line-height: 19.36px;
    height: 41px;
    
}

.password-container-admin {
    display: flex;
    align-items: center;
    justify-content: start;
}
.password-container-admin input {
   display: flex;
   justify-content: space-between;
    padding: 12px 10px 12px 10px;
    border: 1px solid  #D0D0D0 ;
    border-radius: 8px;
    font-size: 16px;
    line-height: 19.36px;
    height: 43px;
}

.togglePassword-admin {
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right:7.5%;
}

.submit-btn-admin {
    width: 80%;
    padding:12px, 10px, 12px, 10px;
    background-color:#506CFE;
    color:  #FFFFFF;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.36px;
    height: 43px;   
    font-family: 'Inter', sans-serif;

}

.submit-btn-admin:disabled {
    background-color: #b0b0b0;
    cursor: not-allowed;
}


.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media screen and (max-width:800px) {
    .admin-image-container{
        border-radius: 32px;
        height: 90%;
        margin-top: 20px;
    }
    .admin-form {
        width: 140%;
        margin-left: 10px;
    }
    .password-container-admin{
        display: flex;
        justify-content:flex-start;
    }
    .togglePassword-admin{
        display: flex;
        justify-content: end;
        left: 75%;
        padding: 10px;
    }
}
@media screen and (min-width: 300px) and (max-width: 700px) {
    .admin-image-container {
        display: none;
    }
    .login-box{
        padding: 15px;
        border: 1px solid #3d3c3c;
        height: 60%;
        margin-top: 55%;
        
    }
    .admin-form{
        margin: 0px;
        width: 125%;
    }
    /* .togglePassword-admin{
        left: 1px;
    } */
    
    
}
`, "",{"version":3,"sources":["webpack://./src/components/login/index.css"],"names":[],"mappings":";;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;AACA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAQ;IACR,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;;AAEpC;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;;;AAGpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gCAAgC;;AAEpC;AACA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,UAAU;IACV,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;GACG,aAAa;GACb,8BAA8B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,gCAAgC;;AAEpC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,0BAA0B;IAC9B;IACA;QACI,aAAa;QACb,oBAAoB;QACpB,SAAS;QACT,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,WAAW;QACX,eAAe;;IAEnB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;;OAEG;;;AAGP","sourcesContent":["\n\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n  font-family: 'Inter', sans-serif;\n}\n.login-page-container {\n    display: flex;\n    height: 100vh;\n    background-color: #FFFFFF;\n    justify-content: center;\n    align-items: center;\n}\n\n.admin-login-content {\n    height: 94vh;\n    display: flex;\n    width: 97%;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.admin-image-container {\n    flex: 1 ;\n    background-color:#F4F4F4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 32px 0px 0px 32px;\n}\n::placeholder{\n    color:  #808080;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16.94px;\n    font-family: 'Inter', sans-serif;\n\n}\n.admin-image-container img {\n    max-width: 80%;\n    object-fit: cover;\n}\n\n\n.login-box {\n    flex: 1;\n    padding: 40px;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.logo-box {\n    font-size: 24px;\n    text-align: center;\n    color: #232323;\n    font-weight: 700;\n    font-family: 'Inter', sans-serif;\n\n    \n}\n\n.form-group-admin {\n    margin-bottom: 20px;\n}\n\n.form-group-admin label {\n  \n    display: block;\n    font-weight:500;\n    margin-bottom: 5px;\n    color:#232323;\n    font-size: 16px;\n    line-height: 22.36px;\n    font-family: 'Inter', sans-serif;\n\n}\n.required {\n    color: red;\n    margin-left:3px;\n}\n\n.admin-form{\n    margin-left: 14%;\n    width: 100%;\n}\n.form-group-admin input {\n    width: 80%;\n    padding: 12px 10px 12px 10px;\n    border: 1px solid  #D0D0D0 ;\n    border-radius: 8px;\n    font-size: 16px;\n    line-height: 19.36px;\n    height: 41px;\n    \n}\n\n.password-container-admin {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n}\n.password-container-admin input {\n   display: flex;\n   justify-content: space-between;\n    padding: 12px 10px 12px 10px;\n    border: 1px solid  #D0D0D0 ;\n    border-radius: 8px;\n    font-size: 16px;\n    line-height: 19.36px;\n    height: 43px;\n}\n\n.togglePassword-admin {\n    background: none;\n    border: none;\n    cursor: pointer;\n    position: absolute;\n    right:7.5%;\n}\n\n.submit-btn-admin {\n    width: 80%;\n    padding:12px, 10px, 12px, 10px;\n    background-color:#506CFE;\n    color:  #FFFFFF;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 19.36px;\n    height: 43px;   \n    font-family: 'Inter', sans-serif;\n\n}\n\n.submit-btn-admin:disabled {\n    background-color: #b0b0b0;\n    cursor: not-allowed;\n}\n\n\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.spinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n@media screen and (max-width:800px) {\n    .admin-image-container{\n        border-radius: 32px;\n        height: 90%;\n        margin-top: 20px;\n    }\n    .admin-form {\n        width: 140%;\n        margin-left: 10px;\n    }\n    .password-container-admin{\n        display: flex;\n        justify-content:flex-start;\n    }\n    .togglePassword-admin{\n        display: flex;\n        justify-content: end;\n        left: 75%;\n        padding: 10px;\n    }\n}\n@media screen and (min-width: 300px) and (max-width: 700px) {\n    .admin-image-container {\n        display: none;\n    }\n    .login-box{\n        padding: 15px;\n        border: 1px solid #3d3c3c;\n        height: 60%;\n        margin-top: 55%;\n        \n    }\n    .admin-form{\n        margin: 0px;\n        width: 125%;\n    }\n    /* .togglePassword-admin{\n        left: 1px;\n    } */\n    \n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
